export const NmlsLicensesLoadError = {
  FORBIDDEN: 'forbidden',
  FAILED: 'failed',
};
